import * as React from 'react';
import { SetYourPasswordPage } from '../../pages/set-your-password/SetYourPasswordPage';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { ROUTES } from '../../../../Routes';
import PageConfig from '../../../../services/userflow/PageConfig';

const config: PageConfig = {
  errorType: ErrorFlow.registerResetPassword,
  startRoute: ROUTES.REGISTER_ENTER_USERNAME,
  analytics: { pageName: 'register-create-password', taskName: 'my-account-registration' },
};

const RegisterSetPasswordPage: React.FC<{}> = () => <SetYourPasswordPage config={config} />;

export { RegisterSetPasswordPage };
